import { useFormEditable } from "../../../hooks/useFormEditable";
import { useFlowNodeMatcher } from "../../../hooks/useFlowNodeMatcher";
import { useModal } from "@/hooks/modals/useModal";
import { usePurchaseRequestDetail } from "../../../hooks/usePurchaseRequest";

export function useRldFormEditable() {
  const { props } = useModal("PURCHASE_REQUEST");
  const { recordId, mode, viewStatus } = props;
  const isStartedMode = mode === "started";
  const isInReviewMode = mode === "inReview";

  const detail = usePurchaseRequestDetail(recordId);
  const { isMainFormDisabled } = useFormEditable();
  const { isMatchPurchaseManagerAuditNodeForRLD } = useFlowNodeMatcher(
    detail?.insId,
  );

  // 满足以下条件时，供应商信息表单禁止编辑
  const supplierInfoFormDisabledRules = [
    isStartedMode,
    isInReviewMode && viewStatus === false,
    isMatchPurchaseManagerAuditNodeForRLD !== true,
  ];
  console.log(
    "🚀 ~ useRldFormEditable ~ supplierInfoFormDisabledRules:",
    supplierInfoFormDisabledRules,
  );

  const isSupplierInfoFormDisabled = supplierInfoFormDisabledRules.some(
    (rule) => !!rule,
  );

  return {
    isMainFormDisabled,
    isSupplierInfoFormDisabled,
  };
}
